<template>
  <div class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid kt-container-home">
    <div class="fullscreen-video-wrap">
      <video autoplay muted loop poster="video/video.jpg">
      <source src="video/video.mp4" type="video/mp4">
        </video>
      </div>
     <div class="header-overlay gradientBackground"></div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PageContent'
}

</script>
<style>
</style>
